import { GeneralState } from '../types'

import { GeneralReducerAction, GeneralAction } from './actionTypes'

export const generalReducer = (state: GeneralState, action: GeneralAction): GeneralState => {
  switch (action.type) {
    case GeneralReducerAction.INCREMENT_FILTERS_CHANGE_COUNT: {
      return {
        ...state,
        filtersChangeCount: state.filtersChangeCount + 1,
      }
    }
    case GeneralReducerAction.SET_CATALOG_TITLE: {
      const { title } = action.payload

      return {
        ...state,
        title,
      }
    }
    default:
      return state
  }
}
